export const environment = {
  production: false,
  estado: "💪 Staging!",
  url_api: "https://hda.api.development.gofeels.com/api/v1",
};
